// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"Select_selectWrapper__2a_yS","selectCustom":"Select_selectCustom__3j3OF","angleDown":"Select_angleDown__2WaiS"};